import type { LaborDay2026SaleVariant } from '../constants/labor-day-2026-sale';

/**
 * Labor Day 2026 sitewide sale variants map to Sanity `promotionId` values (geo/currency-targeted in
 * CMS). Gate on `promotionId` — never on `promoCode`, which is the mutable Braavos coupon at checkout.
 *
 * Market tiers: `sept50` is full_price_market (50% off, 4-month checkout); `sept10` is low_price_market
 * (10% off, annual checkout).
 */
export const LABOR_DAY_2026_FULL_PROMOTION_ID = 'sept50';
export const LABOR_DAY_2026_LOW_PROMOTION_ID = 'sept10';

export type LaborDay2026SaleMarketTier = 'full' | 'low';

export function getLaborDay2026SaleMarketTier(variant: LaborDay2026SaleVariant): LaborDay2026SaleMarketTier {
  return variant === 'labor_day_low' ? 'low' : 'full';
}

export function getLaborDay2026SaleVariant(promotionId: string | null | undefined): LaborDay2026SaleVariant | null {
  if (promotionId === LABOR_DAY_2026_FULL_PROMOTION_ID) {
    return 'labor_day_full';
  }
  if (promotionId === LABOR_DAY_2026_LOW_PROMOTION_ID) {
    return 'labor_day_low';
  }
  return null;
}

export function getLaborDay2026SaleSlideKey(variant: LaborDay2026SaleVariant): string {
  return `labor-day-2026-sale-${variant}`;
}

/** `?force_promo=<promotionId>` wins over the live `usePromotion` response (preview QA only). */
export function resolveLaborDay2026SaleVariant(
  forcedPromotionId: string | null | undefined,
  promotionId: string | null | undefined
): LaborDay2026SaleVariant | null {
  return getLaborDay2026SaleVariant(forcedPromotionId) ?? getLaborDay2026SaleVariant(promotionId);
}
